import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="settings"
export default class SettingsController extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.disableForm);
    this.element.addEventListener("turbo:submit-end", this.enableForm);
  }

  disableForm = () => {
    for (const el of this.element.querySelectorAll("input")) {
      el.disabled = true;
    }
  };

  enableForm = () => {
    for (const el of this.element.querySelectorAll("input")) {
      el.disabled = false;
    }
  };

  toggle() {
    this.element.requestSubmit();
  }
}
